// TODO: Remove ApplicationLaunch once every carrier are in prod for at least 1 day with the new
// ApplicationLaunchMe and ApplicationLaunchAll permissions.

export enum Permission {
  AdminToolsRead = 'adminTools:read',
  AgentLicenseCreate = 'agentLicense:create',
  AgentLicenseRead = 'agentLicense:read',
  ApplicationCopyCreate = 'applicationCopy:create',
  ApplicationCreate = 'application:create',
  ApplicationFileCreate = 'applicationFile:create',
  ApplicationFileRead = 'applicationFile:read',
  ApplicationFileRemove = 'applicationFile:remove',
  ApplicationFileUpdate = 'applicationFile:update',
  ApplicationLaunch = 'application:launch',
  ApplicationLaunchAll = 'application:launch:all',
  ApplicationLaunchMe = 'application:launch:me',
  ApplicationMarketingDataExtract = 'applicationMarketingData:extract:create',
  ApplicationRead = 'application:read',
  ApplicationReadAll = 'application:read:all',
  ApplicationSendDeclaration = 'application:send-declaration',
  ApplicationSignatureRead = 'applicationSignature:read',
  ApplicationSupportApplicationResetSubmittedStatus = 'applicationSupport:application:reset-submitted-status',
  ApplicationSupportApplicationsRead = 'applicationSupport:applications:read',
  ApplicationSupportPIIPHIRead = 'applicationSupport:PIIPHI:read',
  ApplicationSupportSignaturesRead = 'applicationSupport:signatures:read',
  ApplicationSupportUnderwritingOutcomeReportsRead = 'applicationSupport:underwritingOutcomeReports:read',
  ApplicationUpdate = 'application:update',
  AnnouncementCreate = 'announcement:create',
  AnnouncementRead = 'announcement:read',
  AnnouncementUpdate = 'announcement:update',
  AnnouncementRemove = 'announcement:remove',
  AuditLogsRead = 'auditLog:read',

  BackendEventsProcess = 'backendEvents:process', // message-dispatcher must have this permission to send HTTP request to the backend

  CronjobRun = 'cronjob:run',

  EsignAdhocRequestCreate = 'EsignAdhocRequest:create',
  EsignAdhocRequestDelete = 'EsignAdhocRequest:delete',
  EsignAdhocRequestRead = 'EsignAdhocRequest:read',
  EsignAdhocRequestUpdate = 'EsignAdhocRequest:update',
  ESignCeremonyEdit = 'eSignCeremony:edit',
  ESignNotificationRead = 'esignNotification:read',
  ESignNotificationRemove = 'esignNotification:remove',
  ESignNotificationUpdate = 'esignNotification:update',
  ESignSettingCreate = 'eSignSetting:create',
  ESignSettingRead = 'eSignSetting:read',
  ESignSettingRemove = 'eSignSetting:remove',
  ESignSettingUpdate = 'eSignSetting:update',

  FileCreate = 'file:create',
  FileRead = 'file:read',
  FileRemove = 'file:remove',
  FileTemplateCreate = 'fileTemplate:create',
  FileTemplateRead = 'fileTemplate:read',
  FileTemplateRemove = 'fileTemplate:remove',
  FileTemplateRuleCreate = 'fileTemplateRule:create',
  FileTemplateRuleRead = 'fileTemplateRule:read',
  FileTemplateRuleRemove = 'fileTemplateRule:remove',
  FileTemplateRuleUpdate = 'fileTemplateRule:update',
  FileTemplateUpdate = 'fileTemplate:update',
  FileUpdate = 'file:update',

  InsuranceFirmCreate = 'insuranceFirm:create',
  InsuranceFirmRead = 'insuranceFirm:read',
  InsuranceFirmUpdate = 'insuranceFirm:update',
  InsuranceProductCreate = 'insuranceProduct:create',
  InsuranceProductPricingCreate = 'InsuranceProductPricingCreate:create',
  InsuranceProductRead = 'insuranceProduct:read',
  InsuranceProductUpdate = 'insuranceProduct:update',
  IntegrationsHealthRead = 'integrationsHealth:read',

  JetDecisionWidgetView = 'jetDecisionWidget:view',

  LeadArchive = 'lead:archive',
  LeadAssignAll = 'lead:assign:all',
  LeadAssignGroup = 'lead:assign:group',
  LeadAssignMe = 'lead:assign:me',
  LeadAssignRead = 'lead:assign:read',
  LeadCreate = 'lead:create',
  LeadDelete = 'lead:delete',
  LeadEditContacted = 'lead:edit:contacted',
  LeadInviteEmail = 'lead:invite:email',
  LeadInvitePrivate = 'lead:invite:private',
  LeadInvitePublic = 'lead:invite:public',
  LeadReadAll = 'lead:read:all',
  LeadReadGroup = 'lead:read:group',
  LeadReadGroupMGA = 'lead:read:group:mga',
  LeadReadMe = 'lead:read:me',
  LeadUnassignAll = 'lead:unassign:all',
  LeadUnassignMe = 'lead:unassign:me',
  LeadUndelete = 'lead:undelete',
  LinesOfBusinessRead = 'linesOfBusiness:read',

  ManualSubmission = 'submission:manual',

  NotificationCreate = 'notification:create',
  NotificationRead = 'notification:read',
  NotificationUpdate = 'notification:update',

  PaperApplicationCreate = 'paperApplication:create',
  PaperApplicationRead = 'paperApplication:read',
  PaperApplicationUpdate = 'paperApplication:update',
  PdfSummaryRead = 'pdfSummary:read',
  PlatformConfigurationRead = 'platformConfiguration:read',
  PlatformConfigurationSync = 'platformConfiguration:sync',
  PricingFieldIdentifierRead = 'pricingFieldIdentifier:read',
  PricingFieldIdentifierUpdate = 'pricingFieldIdentifier:update',

  QuestionnaireCreate = 'questionnaire:create',
  QuestionnairePartRead = 'questionnairePart:read',
  QuestionnairePreview = 'questionnaire:preview',
  QuestionnaireRead = 'questionnaire:read',
  QuestionnaireRemove = 'questionnaire:remove',
  QuestionnaireUpdate = 'questionnaire:update',

  SalesDecisionRuleCreate = 'salesDecisionRule:create',
  SalesDecisionRuleRead = 'salesDecisionRule:read',
  SalesDecisionRuleRemove = 'salesDecisionRule:remove',
  SalesDecisionRuleUpdate = 'salesDecisionRule:update',
  SettingsCreate = 'settings:create',
  SettingsRead = 'settings:read',
  SettingsUpdate = 'settings:update',
  SignatureRequestCreate = 'signatureRequest:create',
  SignatureRequestEventRead = 'signatureRequestEvent:read',
  SignatureRequestRead = 'signatureRequest:read',
  SignatureRequestRemove = 'signatureRequest:remove',
  SignatureRequestUpdate = 'signatureRequest:update',
  SubmissionUpdate = 'submission:update',

  ThemeCreate = 'theme:create',
  ThemeDelete = 'theme:delete',
  ThemeRead = 'theme:read',
  ThemeUpdate = 'theme:update',
  ThirdPartyIntegrationConfigurationEdit = 'thirdPartyIntegration:edit',
  ThirdPartyIntegrationConfigurationRead = 'thirdPartyIntegration:read',

  UnderwritingRequirementsCreate = 'underwritingRequirements:create',
  UserBulkCreate = 'user:bulk:create',
  UserClearMetadata = 'user:metadata:remove',
  UserCreate = 'user:create',
  UserCreateSuperAdmin = 'user:create:superAdmin',
  UserEditAll = 'user:edit:all',
  UserEditSelf = 'user:edit:self',
  UserListAll = 'user:list:all',
  UserRead = 'user:read',
  UserSyncAll = 'user:sync:all',
}
